// We use context (https://reactjs.org/docs/context.html) to share application state.
// This is a wrapper component that will be called in gatsby-browser.js and gatsby-ssr.js to wrap the whole app
import React from "react";
import { AppContext } from "./src/contexts";
import useAppState from "./src/states";
import { Toaster } from "react-hot-toast";
import { FormProvider } from "./src/contexts/form-context";

const Provider = (props) => {
  const state = useAppState();

  return (
    <AppContext.Provider value={state}>{props.children}</AppContext.Provider>
  );
};

export default ({ element }) => {
  return (
    <Provider>
      <FormProvider>
        {element}
        {/* Toaster placed here to avoid re-render on translate */}
        <Toaster containerClassName="toaster-container" />
      </FormProvider>
    </Provider>
  );
};
